/**
 * 자주묻는 질문 관련 API
 * OpenAPI Generator로 생성된 타입을 사용하며, 기존 Axios 인스턴스와 통합
 */
export class CommunityQNAService {
    constructor(axiosInstance) {
        Object.defineProperty(this, "axios", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.axios = axiosInstance;
    }
    /**
     * QnA 상세 조회
     * 특정 QnA 문의의 상세 정보를 조회합니다
     * @param id - QnA ID
     * @returns QnA 상세 조회 결과
     */
    getQnaDetail(id) {
        return this.axios.get(`/co/v1/support/qnas/${id}`);
    }
    /**
     * QnA 문의 수정
     * QnA 문의를 수정합니다. 파일 첨부 및 삭제 가능합니다
     * @param id - QnA ID
     */
    updateQna(id, request) {
        const formData = new FormData();
        formData.append('title', String(request.title));
        formData.append('detail', String(request.detail));
        formData.append('category', String(request.category));
        formData.append('removedFileList', String(request.removedFileList));
        // fileList (파일 배열)
        request.fileList.forEach((file) => {
            formData.append('fileList', file);
        });
        return this.axios.put(`/co/v1/support/qnas/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }
    /**
     * QnA 문의 삭제
     * QnA 문의를 삭제합니다. 답변이 완료된 문의는 삭제할 수 없습니다
     * @param id - QnA ID
     * @returns QnA 문의 삭제 결과
     */
    deleteQna(id) {
        return this.axios.delete(`/co/v1/support/qnas/${id}`);
    }
    /**
     * QnA 목록 조회
     * 사용자의 QnA 문의 목록을 페이징으로 조회합니다
     * @param pageable - pageable
     * @returns QnA 목록 조회 결과
     */
    getQnas(pageable) {
        return this.axios.get(`/co/v1/support/qnas`, {
            params: {
                ...pageable,
            },
        });
    }
    /**
     * QnA 문의 등록
     * QnA 문의를 등록합니다. 파일 첨부 가능합니다
     */
    createQna(request) {
        const formData = new FormData();
        formData.append('title', String(request.title));
        formData.append('detail', String(request.detail));
        formData.append('category', String(request.category));
        // fileList (파일 배열)
        request.fileList.forEach((file) => {
            formData.append('fileList', file);
        });
        return this.axios.post(`/co/v1/support/qnas`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }
}
//# sourceMappingURL=qna.service.js.map